// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b2a3c273","854":"2a5f751c"}[chunkId] + ".chunk.js";
};